import { takeLatest, call, put } from 'redux-saga/effects'

import externalCoursesCertificatesList, {
  GetListResponse,
} from 'api/externalCoursesCertificates/List'
import {
  EXTERNAL_COURSE_CERTIFICATES_GET_LIST,
  Actions,
} from '../../actions/externalCourseCertificate.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'

const pattern = EXTERNAL_COURSE_CERTIFICATES_GET_LIST

export type ExternalCourseParticipantsListAction = ActionWithPayload<
  typeof pattern,
  undefined
>

function* externalCoursesCertificatesListEffectSaga() {
  try {
    const { data }: GetListResponse = yield call(
      externalCoursesCertificatesList
    )
    yield put(Actions.setListSuccess(data))
  } catch (error) {
    console.error('error: ', error)
    yield put(Actions.setLoading(false))
  }
}

export function* externalCoursesCertificatesListWatcherSaga() {
  yield takeLatest(pattern, externalCoursesCertificatesListEffectSaga)
}
